module.exports = __webpack_public_path__ + "img/docs-delete-icon.3fbc09a4.svg";